import { render, staticRenderFns } from "./ProfilePictureUploader.vue?vue&type=template&id=6205ba32"
import script from "./ProfilePictureUploader.vue?vue&type=script&lang=js"
export * from "./ProfilePictureUploader.vue?vue&type=script&lang=js"
import style0 from "./ProfilePictureUploader.vue?vue&type=style&index=0&id=6205ba32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports